module.exports = __webpack_public_path__ + "assets/img/3-1.89f235bc.jpg";